import {
  DataExportRes,
  DataExportReq
} from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'

export class DataExportGateway {
  static postDataExport = async (
    params: DataExportReq,
    displayStartYear: string
  ) => {
    const req: DataExportReq = {
      searchCondition: {
        ...params.searchCondition,
        totalCostFrom: params.searchCondition.totalCostFrom !== null ? params.searchCondition.totalCostFrom * 1000000 : params.searchCondition.totalCostFrom,
        totalCostTo: params.searchCondition.totalCostTo !== null ? params.searchCondition.totalCostTo * 1000000 : params.searchCondition.totalCostTo,
        ourCompanyTotalCostFrom: params.searchCondition.ourCompanyTotalCostFrom !== null ? params.searchCondition.ourCompanyTotalCostFrom * 1000000 : params.searchCondition.ourCompanyTotalCostFrom,
        ourCompanyTotalCostTo: params.searchCondition.ourCompanyTotalCostTo !== null ? params.searchCondition.ourCompanyTotalCostTo * 1000000 : params.searchCondition.ourCompanyTotalCostTo
      },
      generalPurposeSearchList: params.generalPurposeSearchList,
      outputItemList:
        params.outputItemList
          .filter(oi => oi.outputCheck === true || oi.sortOrder !== null)
          .map(oi => ({
            ...oi,
            outputCheck: oi.outputCheck === true ? 1 : 0,
            outputItemDispNmWithAnnotation: null,
            sortMethod: oi.sortMethod === '' ? '1' : oi.sortMethod
          })),
      displayStartYear
    }
    return await yamadumiApi.post<DataExportRes>(
      '/api/report/data-export', { data: req }
    )
  }
}
